import React, { useState, useEffect } from 'react';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Carousel } from 'react-responsive-carousel';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { FaBars, FaAngleRight } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import Menu from './Menu'; // Import the Menu component
import { baseURL, baseURLWithoutAPI } from '../../Api';

import '../css/dashboard.scss';

const Dashboard = () => {
  const [banners, setBanners] = useState([]);
  const [username, setUsername] = useState('');
  const [avatarUrl, setAvatarUrl] = useState('');

  const [phoneNumber, setPhoneNumber] = useState('');
  const [enrolledCourses, setEnrolledCourses] = useState([]);
  const [otherCourses, setOtherCourses] = useState([]);
  const [menuOpen, setMenuOpen] = useState(false); // State to manage menu open/close
  const [loading, setLoading] = useState(true); // Loading state to prevent repeated requests
  const [hasCheckedAuth, setHasCheckedAuth] = useState(false); // Flag to prevent repeated handling of 401
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    const userDataString = localStorage.getItem('user');

    if (!token || !userDataString) {
      navigate('/');
      return;
    }

    const userData = JSON.parse(userDataString);
    setUsername(userData.name);
    setPhoneNumber(userData.phone);
    setAvatarUrl('https://avatar.iran.liara.run/public/boy?username=Ash');

    const fetchData = async () => {
      try {
        const [bannerRes, allCoursesRes, enrolledCoursesRes] = await Promise.all([
          axios.get(baseURL + 'appBanners'),
          axios.get(baseURL + 'all-courses', {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }),
          axios.get(baseURL + 'get-enrolled-courses', {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }),
        ]);

        if (!hasCheckedAuth && (bannerRes.status === 401 || allCoursesRes.status === 401 || enrolledCoursesRes.status === 401)) {
          setHasCheckedAuth(true);
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          navigate('/');
        } else {
          setBanners(bannerRes.data.data);
          setOtherCourses(allCoursesRes.data.data);
          setEnrolledCourses(enrolledCoursesRes.data.status === 'success' ? enrolledCoursesRes.data.data : []);
        }
      } catch (error) {
        console.error(error);
        if (!hasCheckedAuth && error.response?.status === 401) {
          setHasCheckedAuth(true);
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          navigate('/');
        }
      } finally {
        setLoading(false); // Set loading to false after the data fetch is done
      }
    };

    fetchData();
  }, [navigate, hasCheckedAuth]);

  // Function to toggle menu
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  if (loading) {
    return <div className='loading'>Loading...</div>; // Show a loading spinner or message while data is being fetched
  }

  return (
    <div className="root-component">
      {/* Menu Component */}
      <Menu
        username={username}
        phoneNumber={phoneNumber}
        isOpen={menuOpen}
        handleCloseMenu={toggleMenu}
        avatarUrl={avatarUrl}
      />

      {/* Hamburger Icon */}
      <div className="hamburger-menu" onClick={toggleMenu}>
        <FaBars /> <span>Menu</span>
      </div>

      <div className="hi-name">
        <div className="hi-text">
          Hi <span> {username}</span>,
        </div>
        <p>Welcome Back !</p>
      </div>

      <div className="carousel-banners hide-on-large-screen">
        <Carousel showThumbs={false} showStatus={false}>
          {banners.map((banner) => (
            <div key={banner.id}>
              <img
                src={`${baseURLWithoutAPI}${banner.imageUrl}`}
                alt={banner.title}
              />
            </div>
          ))}
        </Carousel>
      </div>

      <div className="dashboard-content">
        <div className="enrolled-courses">
          {enrolledCourses.length > 0 ? (
            <h2 className="title center">Your Enrolled Courses</h2>
          ) : (
            <h2 className="title center">No Courses Enrolled</h2>
          )}
          <div className="enrolled-courses-list">
            {enrolledCourses.map((course) => (
              <div key={course.id} className="enrolled-course">
                <Link to={`/subjects/${course.id}`} className="course-link">
                  <img
                    className="course-thumbnail"
                    src={`${baseURLWithoutAPI}${course.package_image}`}
                    alt="course-thumbnail"
                  />
                  <div className="course-details">
                    <h3 className="course-title">{course.package_name}</h3>
                  </div>
                  <div className="icon">
                    <FaAngleRight />
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>

        <div className="other-courses">
          <h2 className="title center">All Courses</h2>
          <div className="other-courses-list">
            {otherCourses.map((course) => (
              <div key={course.id} className="other-course">
                <Link to={`/subjects/${course.id}`} className="course-link">
                  <img
                    className="course-thumbnail"
                    src={`${baseURLWithoutAPI}${course.package_image}`}
                    alt="course-thumbnail"
                  />
                  <div className="course-details">
                    <h3 className="course-title">{course.package_name}</h3>
                  </div>
                  <div className="icon">
                    <FaAngleRight />
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
